<template>
  <div class="faq-section spad">
    <div class="container">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      content: "",
      id: null,
    };
  },
  beforeMount() {
    const query = this.$route.query;

    if (query.type && query.type === "apercu" && query.content) {
      // Display preview content directly
      this.content = query.content;
    } else {
      // Fetch content from API
      this.getPageType(this.type);
    }
  },
  methods: {
    getPageType(type) {
      this.$axios({
        url: `page/${type}`,
        method: "GET",
      })
        .then((response) => {
          const data = response.data[0];
          if (data) {
            this.content = data.content;
            this.id = data.id;
          }
        })
        .catch((err) => {
          console.error("Error loading page:", err.response?.data || err);
        });
    },
  },
};
</script>

<style scoped>
.faq-section {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>
